import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const RecaptchaActions = createActionGroup({
  source: 'Recaptcha',
  events: {
    'Set Recaptcha': props<{ isResolved: boolean; isError: boolean }>(),
    'Check Recaptcha': emptyProps(),
    'On Error': props<{ error: HttpErrorResponse }>(),
  },
});
